import { Typography } from 'antd'

const { Title, Paragraph } = Typography

const CGV = () => {
  return (
    <>
      <Title level={2}>Conditions Générales de Vente</Title>
      <Paragraph>Lorem ipsum dolor sit amet</Paragraph>
    </>
  )
}

export default CGV
